// eslint-disable-next-line import/prefer-default-export
export const createImageLoading = ({ image }) => image.loading;
export const createImageData = ({ image }) => image.data;
export const createImageByUrlLoading = ({ imageByUrl }) => imageByUrl.loading;
export const createImageByUrlData = ({ imageByUrl }) => imageByUrl.data;
export const createImageByUrlLocalId = ({ imageByUrl }) => imageByUrl.localId;
